

const CallToAction = () => {
  return (
    <div className="bg-blue-600 text-white rounded-2xl py-12 px-6 mx-20 mb-10 text-center">
      <h2 className="text-2xl font-semibold mb-4">Ready to transform your learning institution?</h2>
      <button className="bg-white text-blue-600 font-medium px-6 py-2 rounded-xl
       hover:bg-gray-100 transition">
        Let’s Partner
      </button>
    </div>
  )
}

export default CallToAction
